import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage, FormattedNumber } from 'react-intl';

const FormatPrice = ({ price, ...props }) => (
  <>
    <FormattedNumber value={price / 100} {...props} />
    &nbsp;
    <FormattedMessage id="SEK" defaultMessage="SEK" />
  </>
);

FormatPrice.propTypes = {
  price: PropTypes.number.isRequired,
};

export default FormatPrice;
